import { combineReducers } from 'redux';
import data from './data';
import modals from './modals';

const root = combineReducers({ data, modals });

export default root;

export type NavBarState = ReturnType<typeof root>;
